import { CurrencyLocation, DecimalSeparator, RoundingMethod, ThousandsSeparator } from '../../filters/currency/currency-formatter.const';
import { CurrencyOptions } from '../currency.interfaces';

export const EUR_ES: CurrencyOptions = {
  currencyLocation: CurrencyLocation.APPEND,
  currencySpacing: true,
  decimalDigits: 2,
  decimalSeparator: DecimalSeparator.COMMA,
  currencySymbol: '€',
  hideDecimalsIfZero: false,
  roundingMethod: RoundingMethod.ROUND,
  thousandsSeparator: ThousandsSeparator.NONE
};
